/*
 *   Copyright (c) 2021 Sok Channy
 *   All rights reserved.
 */
// Copyright 2021 channysok
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
//     http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { ApiSrc } from "../../../resources/ApiSrc";
import { GetResultObject, PostRequest } from "../../API";

const TYPES = {
    REQUEST_USER_LIST: "REQUEST_USER_LIST",  
    REQUEST_USER_LIST_SUCCESS: "REQUEST_USER_LIST_SUCCESS",
    REQUEST_USER_LIST_FAILED: "REQUEST_USER_LIST_FAILED",    

    REQUEST_UPDATE_USER: "REQUEST_UPDATE_USER",
    REQUEST_UPDATE_USER_SUCCESS: "REQUEST_UPDATE_USER_SUCCESS",

    REQUEST_CREATE_USER: "REQUEST_CREATE_USER",
    REQUEST_CREATE_USER_SUCCESS: "REQUEST_CREATE_USER_SUCCESS",

    REQUEST_USER_INFO: "REQUEST_USER_INFO",
    REQUEST_USER_INFO_SUCCESS: "REQUEST_USER_INFO_SUCCESS",
};
  
const getUserList = (body, params) => {
    return (dispatch) => {
      dispatch({
        type: TYPES.REQUEST_USER_LIST,
        payload: {},
      });
      PostRequest(
          ApiSrc.GET_USER_LIST, body, params
      ).then(result => {
        GetResultObject(result, 'data.content', 200, (data, page) => {
          dispatch({
            type: TYPES.REQUEST_USER_LIST_SUCCESS,
            payload: {data: data, ...page},});
          })    
       })
  
    }
}

const getUserDetail = (body) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_USER_INFO,
      payload: {},
    });
    PostRequest(
        ApiSrc.GET_USER_INFO, body
    ).then(result => {
      GetResultObject(result, 'data', 200, (data, page) => {
        dispatch({
          type: TYPES.REQUEST_USER_INFO_SUCCESS,
          payload: {data: data, ...page},});
        })    
     })

  }
}

const createUser = (body) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_CREATE_USER,
      payload: {},
    });
    PostRequest(
        ApiSrc.CREATE_USER, body
    ).then(result => {
      GetResultObject(result, 'data', 200, (data, page) => {
        dispatch({
          type: TYPES.REQUEST_CREATE_USER_SUCCESS,
          payload: {data: data, ...page},});
        })    
     })
  }
}

const createUserSuccess = (user) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_CREATE_USER_SUCCESS,
      payload: {data: user},
    });      
  }
}

const updateUser = (body) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_UPDATE_USER,
      payload: {},
    });
    PostRequest(
        ApiSrc.UPDATE_USER_INFO, body
    ).then(result => {
      GetResultObject(result, 'data', 200, (data, page) => {
        dispatch({
          type: TYPES.REQUEST_UPDATE_USER_SUCCESS,
          payload: {data: data, ...page},});
        })    
     })
  }
}

const updateUserSuccess = (data) => {
  return (dispatch) => {
    dispatch({
      type: TYPES.REQUEST_UPDATE_USER_SUCCESS,
      payload: {data: data},
    });    
  }  
}


export default {
    TYPES, getUserList, updateUser, updateUserSuccess, createUser, getUserDetail, createUserSuccess
}